import { render } from "./AuthorizeModal.vue?vue&type=template&id=3fe0907b"
import script from "./AuthorizeModal.vue?vue&type=script&lang=js"
export * from "./AuthorizeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__